// extracted by mini-css-extract-plugin
export default {"member":"Members_member__2cfGH","profile_image":"Members_profile_image__vm0XC","name":"Members_name__CoNLc"};